import React from 'react';
import './landing.css';

function C2wQuizeethonLanding() {
  return (
    <div className="C2wQuizeethonLanding_ctn">
      <div className="C2wQuizeethonLanding_hero">
        {/* Logo */}
        <img
          className="C2wQuizeethonLogo"
          src="/assets/quizeethon/landing/QuizeethonLogo.png"
          alt="Quizeethon Logo"
        />

        {/* Badge */}
        <div className="qz-hero-badge">
          <span>🤔</span> THINK MORE, CHOOSE ONE
        </div>

        {/* Main Headline */}
        <h1 className="qz-hero-title">
          Test Your <span className="qz-gradient-gold">Coding Skills</span> Through <span className="qz-gradient-purple">Quiz Competitions</span>
        </h1>

        {/* Subtitle */}
        <p className="qz-hero-subtitle">
          Master real-world MCQs, competitive logic questions, and speed challenges in Core2web Quizeethon.
        </p>
      </div>
    </div>
  );
}

export default C2wQuizeethonLanding;
